import { render, staticRenderFns } from "./AwlConfirm.vue?vue&type=template&id=2daf8344&"
import script from "./AwlConfirm.vue?vue&type=script&lang=js&"
export * from "./AwlConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AwlConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports